// extracted by mini-css-extract-plugin
export default {"background":"light_background__wMMqb","glas":"light_glas__2wzkz"};